import { useMemo } from 'react';
import { useRecoilState } from 'recoil';

import { SectionName, useSectionState } from '@/context';

export const useSection = () => {
  const [state, setState] = useRecoilState(useSectionState);

  const section = useMemo(() => state.current, [state.current]);

  const setSection = (value: SectionName) => {
    setState((old) => ({ ...old, current: value }));
  };

  return { section, setSection };
};
